module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('MC_Calendar', {
		
		configure: function(options) {
			this.currentType = null;
			this.periodStart = null;
			this.periodEnd = null;

			this.registerOptions('', {
				autoRender: true,
				container: '.mc-calendar',
				template: 'mc_calendar',
				currentType: 'monthly',
				periodSelector: '.period',

				handleDom: {
					next: {
						target: '.arr.arr-rt',
						event: 'click',
						callback: 'next' 
					},
					prev: {
						target: '.arr.arr-lt',
						event: 'click',
						callback: 'prev' 
					},
					changeType: {
						target: '.tab',
						event: 'click',
						callback: '_changeType' 
					}
				},

				'hooks.onAddedToDom': fox.bind(function (argument) {
					this.dispatchEvent('change');
					this.renderPeriod();
				}, this)
			});
			
			this.callParent('configure', arguments);
		},

		running: function () {
			this.currentType = this.getOption('currentType');

			this.resetDate();

			this.callParent('running', arguments);
		},

		_next: function () {
			var date;

			switch (this.currentType) {
				case 'daily':
					this.changeDay('next');
				break;

				case 'weekly':
					this.changeWeek('next');
				break;

				case 'monthly':
					this.changeMonth('next');
				break;
			}

		},

		_prev: function () {
			switch (this.currentType) {
				case 'daily':
					this.changeDay('prev');
				break;

				case 'weekly':
					this.changeWeek('prev');
				break;

				case 'monthly':
					this.changeMonth('prev');
				break;
			}
			
		},

		next: function () {
			this._next();
			this.renderPeriod();
			this.dispatchEvent('change');
		},

		prev: function () {
			this._prev();
			this.renderPeriod();
			this.dispatchEvent('change');
		},

		resetDate: function () {
			var date = new Date();
			this.currentDate = date.getTime();
			this.currentYear = date.getFullYear();

			switch (this.currentType) {
				case 'daily':
					this.changeDay('current');
				break;

				case 'weekly':
					this.changeWeek('current');
				break;

				case 'monthly':
					this.changeMonth('current');
				break;
			}
		},

		getCurrentType: function () {
			return this.currentType;
		},

		getPeriodStart: function () {
			return this.periodStart;
		},

		getPeriodEnd: function () {
			return this.periodEnd;
		},

		getUnixPeriodStart: function (param) {
			return Math.round((new Date(this.getPeriodStart())).getTime() / 1000);
		},

		getUnixPeriodEnd: function (param) {
			return Math.round((new Date(this.getPeriodEnd())).getTime() / 1000);
		},

		getYear: function (argument) {
			return this.currentYear;
		},

		changeMonth: function (delta) {
			var month = new Date(this.currentDate).getMonth();
			var deltaMonth;
			var countedMonth;
			var date;

			switch (delta) {
				case 'next':
					deltaMonth  = ++month;
				break;

				case 'current':
					deltaMonth = month;
				break;

				case 'prev':
					deltaMonth = --month;
				break;
			};

			if (deltaMonth < 0 ) {
				deltaMonth = 11;
				this.currentYear--;
			}

			if (deltaMonth > 11 ) {
				deltaMonth = 0;
				this.currentYear++;
			}
			
			countedMonth = new Date(this.currentYear, deltaMonth, 1).getMonth();

			this.periodStart = new Date(this.currentYear, countedMonth, 1).getTime();
			this.periodEnd = new Date(this.currentYear, countedMonth + 1, 0).getTime();

			this.currentDate = this.periodStart;
		},

		changeWeek: function (week) {
			/*var date = new Date(this.currentDate);
			var currentDate = date.getDate();
			var delta;*/
			var date;
			var currentDate;
			var delta;
			var deltaPeriod;

			switch (week) {
				case 'next':
					date = new Date(this.periodEnd);
					currentDate = date.getDate()

					this.periodStart = date.getTime() + (24 * 60 * 60 * 1000);
					this.periodEnd = date.setDate(currentDate + 7);

					deltaPeriod = this.periodEnd;
				break;

				case 'current':
					date = new Date(this.currentDate);
					currentDate = date.getDate();
					delta = (currentDate - 7);

					this.periodEnd = date.getTime();
					this.periodStart = date.setDate(delta);

					deltaPeriod = this.periodStart;
				break;

				case 'prev':
					date = new Date(this.periodStart);
					currentDate = date.getDate();

					this.periodEnd = date.getTime() - (24 * 60 * 60 * 1000);
					this.periodStart = date.setDate(currentDate - 7);

					deltaPeriod = this.periodStart;


				break;
			};

			this.currentDate = deltaPeriod;
			this.currentYear = date.getFullYear();

		},

		changeDay: function (day) {
			var delta;
			var result;

			switch (day) {
				case 'next':
					delta = (24 * 60 * 60 * 1000);
				break;

				case 'current':
					delta = 0;
				break;

				case 'prev':
					delta = -(24 * 60 * 60 * 1000);
				break;
			};
			result = this.currentDate + delta;
			this.currentDate = this.periodStart = this.periodEnd = result;
			this.currentYear = new Date(this.currentDate).getFullYear();
		},

		_changeType: function (el) {
			var period = fox.dom.wrap(el).attr('data-period');
			this.changeType(period);
			this.changeTab(period);
		},

		changeType: function (type) {
			this.currentType = type;
			this.resetDate();
			this.renderPeriod();
			this.dispatchEvent('change');
		},

		changeTab: function (period) {
			var tabs = fox.dom.select('.tab[data-period]');

			fox.each(tabs, function (tab) {
				var tab = fox.dom.wrap(tab);
				var p = tab.attr('data-period');

				tab.removeClass('active');

				if (p == period) {
					tab.addClass('active');
				};
				
			}, this)
		},

		renderPeriod: function () {
			var place = this.dom1(this.getOption('periodSelector'));

			if (!place) {
				return;
			};

			place.innerHTML = this.translatePeriod();
		},

		translatePeriod: function () {
			var result = 'result';
			var startDate = new Date(this.periodStart);
			var endDate = new Date(this.periodEnd);
			var startMonth = fox.utils.getMonthsArray()[startDate.getMonth()];
			var endMonth = fox.utils.getMonthsArray()[endDate.getMonth()];
			var sameMonth = startDate.getMonth() == endDate.getMonth();

			switch (this.currentType) {
				case 'daily':
					result = startMonth + ' - ' + startDate.getDate() + ', ' + this.currentYear;
				break;

				case 'weekly':
					if (sameMonth) {
						result = startMonth + ', ' + startDate.getDate() + ' - ' + endDate.getDate() + ', ' + this.currentYear;
						break;
					}

					result = startMonth + ' - ' + startDate.getDate() + ', ' + endMonth + ' - ' + endDate.getDate() + ', ' + this.currentYear;
				break;

				case 'monthly':
					result = startMonth + ', ' + this.currentYear;
				break;
			}

			return result;
		}

	}, 'Widget');
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/mcCalendar.js
// module id = 326
// module chunks = 2